import { LocationCoordinates } from "graphql/generated/types";
import { useState } from "react";

export function useLazyGeolocation() {
    const [location, setLocation] = useState<LocationCoordinates | null>(null);
    if (!navigator.geolocation) return null;

    return {
        update: async (): Promise<LocationCoordinates> => {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const coords = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        setLocation(coords);
                        resolve(coords);
                    },
                    (error) => {
                        setLocation(null);
                        reject(error);
                    },
                );
            });
        },
        coordinates: location,
    };
}
